import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetEmrIntegrationProgressRequestDtoSchema = z.object({});

const GetEmrIntegrationProgressResponseDtoSchema = z.object({
  progress: z.number().optional(),
  title: z.string().optional(),
  error: z.string().optional(),
});

export type GetEmrIntegrationProgressRequestDto = z.infer<
  typeof _GetEmrIntegrationProgressRequestDtoSchema
>;
export type GetEmrIntegrationProgressResponseDto = z.infer<
  typeof GetEmrIntegrationProgressResponseDtoSchema
>;

export const getEmrIntegrationProgress = (config?: AxiosRequestConfig) => {
  return api
    .get('/integrations/sync-progress', config)
    .then(responseContract(GetEmrIntegrationProgressResponseDtoSchema));
};
